import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import NotJustRobotics from "./sections/NotJustRobotics";
import AgePrograms from "./sections/AgePrograms";
import StudentBuilds from "./sections/StudentBuilds";
import AcademyStats from "./sections/AcademyStats";
import FacultyTeaser from "./sections/FacultyTeaser";
import LatestInsights from "./sections/LatestInsights";
import FaqAccordion from "./sections/FaqAccordion";
import ParentTestimonials from "./sections/ParentTestimonials";
import GlobalStemEcosystem from "./sections/GlobalStemEcosystem";
import Trial from "./sections/Trial";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <NotJustRobotics id='not-just-robotics' />
      <AgePrograms />
      <StudentBuilds />
      <AcademyStats />
      <FacultyTeaser />
      <LatestInsights />
      <FaqAccordion />
      <ParentTestimonials />
      <GlobalStemEcosystem />
      <Trial />
      <Footer />
    </div>;
}